"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeArea = exports.TextArea = exports.Statuarea = exports.SentWrapper = exports.ReceivedWrapper = exports.IconAreaSent = exports.IconAreaRead = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var Wrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: var(--font-family);\n  padding: var(--spacing-1) var(--spacing-2);\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  max-width: 100%;\n  @media (min-width: 840px) {\n    max-width: 85%;\n  }\n  @media (min-width: 1272px) {\n    max-width: 75%;\n  }\n  ", "\n"])), function (_ref) {
  var isEmoji = _ref.isEmoji;
  return isEmoji && "\n    border: var(--border-radius-lg) var(--border-radius-none);\n    flex-direction: column;\n  ";
});
var SentWrapper = exports.SentWrapper = (0, _styledComponents["default"])(Wrapper)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background-color: var(--color-secondary-70);\n  border-radius:\n    var(--border-radius-lg)\n    var(--border-radius-md)\n    var(--border-radius-none)\n    var(--border-radius-lg);\n  color: var(--color-secondary-130);\n  align-self: flex-end;\n\n"])));
var ReceivedWrapper = exports.ReceivedWrapper = (0, _styledComponents["default"])(Wrapper)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background-color: var(--color-neutral-80);\n  border-radius:\n    var(--border-radius-none)\n    var(--border-radius-lg)\n    var(--border-radius-lg)\n    var(--border-radius-md);\n  color: var(--color-neutral-130);\n  align-self: flex-start;\n"])));
var TextArea = exports.TextArea = _styledComponents["default"].span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-right: var(--spacing-1);\n  font-size: var(--font-size-xs);\n  overflow-wrap: anywhere;\n  white-space: pre-wrap;\n  text-align: left;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_ref2) {
  var isEmoji = _ref2.isEmoji;
  return isEmoji && "\n    letter-spacing: 5px;\n  ";
}, function (_ref3) {
  var isEmoji = _ref3.isEmoji,
    numberEmoji = _ref3.numberEmoji;
  return isEmoji && numberEmoji === 1 && "\n    font-size: var(--font-size-xxxl);\n    margin: -6px 0 -4px 0;\n    width: unset;\n  ";
}, function (_ref4) {
  var isEmoji = _ref4.isEmoji,
    numberEmoji = _ref4.numberEmoji;
  return isEmoji && numberEmoji === 2 && "\n    font-size: var(--font-size-xxl);\n    margin: 0;\n    width: unset;\n  ";
}, function (_ref5) {
  var isEmoji = _ref5.isEmoji,
    numberEmoji = _ref5.numberEmoji;
  return isEmoji && numberEmoji === 3 && "\n    font-size: var(--font-size-lg);\n    margin: 0;\n    width: unset;\n  ";
}, function (_ref6) {
  var isEmoji = _ref6.isEmoji,
    numberEmoji = _ref6.numberEmoji;
  return isEmoji && numberEmoji >= 4 && "\n    font-size: var(--font-size-md);\n    margin: var(--spacing-1) 0;\n  ";
});
var TimeArea = exports.TimeArea = _styledComponents["default"].span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-right: var(--spacing-0-5);\n  opacity: var(--opacity-intense);\n  font-size: var(--font-size-xxxs);\n\n  ", "\n"])), function (_ref7) {
  var isEmoji = _ref7.isEmoji;
  return isEmoji && "\n    color: var(--color-secondary-130);\n    opacity: var(--opacity-intense);\n  ";
});
var IconAreaSent = exports.IconAreaSent = _styledComponents["default"].span(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  opacity: var(--opacity-intense);\n  color: var(--color-secondary-130);\n  display: flex;\n  align-items: end;\n\n  ", "\n"])), function (_ref8) {
  var isEmoji = _ref8.isEmoji;
  return isEmoji && "\n    font-size: var(--font-size-xs);\n  ";
});
var IconAreaRead = exports.IconAreaRead = _styledComponents["default"].span(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  color: var(--color-feedback-info-100);\n  display: flex;\n  align-items: end;\n\n  ", "\n"])), function (_ref9) {
  var isEmoji = _ref9.isEmoji;
  return isEmoji && "\n    font-size: var(--font-size-xs);\n  ";
});
var Statuarea = exports.Statuarea = _styledComponents["default"].div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  ", "\n"])), function (_ref10) {
  var isEmoji = _ref10.isEmoji;
  return isEmoji && "\n    font-size: var(--font-size-xxxl)\n  ";
});